import React,{Fragment} from "react";
import { Modal, Button } from "react-bootstrap";
import check from "../../../assets/check.png"
import "../../UI Component/Modal/commonModals.css";

const PatientSuccess = ({
    show,
    okayClickHandler,
}) => {
    return (
      <Fragment>
       {show && <Modal show={show} onHide={okayClickHandler} centered >
        <button
            className=" border-0 bg-white text-right pr-3 pt-2 "
            onClick={okayClickHandler}
          >
            Close{" "}<span style={{ fontSize: "15px" }}>X</span>{" "}
          </button>
      
          <Modal.Body className="p-4" style={{marginBottom:"1.75rem"}}>
            <div className="text-center align-items-center">
              <img src={check} alt="Success" style={{ width: "77px", height: "77px" }}/>
              <h2 className="header-text mt-2">
              Records Uploaded Successfully
              </h2>
            </div>
            <div className="d-flex flex-column justify-content-center align-items-center">
              <Button
                className="custom-modal-button yes-button border-0 rounded-pill mb-2"
                style={{ backgroundColor: "#17BAE0", color: "#fff" }}
                onClick={okayClickHandler}
              >
                Okay
              </Button>
            </div>
          </Modal.Body>
    </Modal>}
      </Fragment>
  )
}

export default PatientSuccess;